$(document).ready(function(){

    var winW = $(window).width();


	// Header

  var barraH = $('.bar-mes').outerHeight();
  var infoH = $('.barra').outerHeight();
  var headerH = $('header').outerHeight();

  $(window).load(function(){
    var barraH = $('.bar-mes').outerHeight();
    var infoH = $('.barra').outerHeight();
    var headerH = $('header').outerHeight();
  });

  if ( winW > 830 ) {

    $('body').css('padding-top', barraH + infoH + headerH);
    $('header').css('top', barraH + infoH);
    $('.barra').css('top', barraH);

    $(window).scroll(function(){
      if ($(window).scrollTop() > barraH + infoH) {
        $('header').addClass('fix');
      } else {
        $('header').removeClass('fix');
        $('header').css('top', barraH + infoH);
      }
    });

  } else {

    var padTop = barraH + headerH;
    console.log('padTop: ' + padTop);

    $('body').css('padding-top', padTop);
    $('header').css('top', barraH);

    $(window).scroll(function(){
      if ($(window).scrollTop() > barraH) {
        $('header').addClass('fix');
      } else {
        $('header').removeClass('fix');
        $('header').css('top', barraH);
      }
    });

  }

	$('header .icons li .search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});

    $('header .big-search .cerrar-big-search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});

	$('header .icons li .cart').click(function(){
		$('#minicart').addClass('show');
	});
	$('#minicart .cerrar').click(function(){
		$('#minicart').removeClass('show');
	});

	$('header .show-menu').click(function(){
		$('nav').addClass('show');
      console.log('click222!');
	});

	$('nav .top .cerrar').click(function(){
      console.log('click!');
		$('nav').removeClass('show');
      console.log('click!');
	});

  	// Product

    $('.product .deon > h3').each(function(){
      $(this).addClass('accor');
      $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
    })

    $('.product .deon h3').click(function(){
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });

  $('.featured-collection ul .item[data-id="5125822054535"]').remove();
  $('.featured-collection ul .item[data-id="5125823266951"]').remove();

    // Pop Up

    $('#popup .cerrar').click(function(){
      $('#popup').removeClass('show');
    });

    // Cart

    setTimeout(function() {
      $('.cart-upsell').addClass('show');
    },5000);

    $('.cart-upsell .close').click(function(){
      $('.cart-upsell').removeClass('show');
    });


    if ( winW < 830 ) {

      var headerH = $('header').outerHeight();

      //$('nav ul.menu > li.site-nav--has-dropdown > a').removeAttr('href');

      $('nav ul.menu > li.site-nav--has-dropdown > a').each(function(){
        var href = $(this).attr('href');
        console.log('href: ' + href);

        $(this).click(function(e){
        	e.preventDefault();
            $(this).click(function(){
				//window.location.href = href;
            });
        });

      });

      $('nav ul.menu > li.site-nav--has-dropdown').click(function(){
        $(this).siblings().children('.sub-menu').removeClass('show');
        $(this).children('.sub-menu').toggleClass('show');
      });
    }

});
